import React, { useEffect, useState } from "react";
import ModalTiny from "react-bootstrap/Modal"
import { useStaticQuery, graphql } from "gatsby"
import { Col, Row, Container, Navbar, Nav } from 'react-bootstrap';
import DownloadPDForm from "../forms/download-form"
import { slugify } from "../common/site/functions"

import "../MarketData/MarketData.scss";
import "./DownloadPDF.scss";


const DownloadPDF = (props) => {
  const data = useStaticQuery(graphql`
      query{
        strapiGlobalModules {
          downloads {
            file {
              absolutePath
              publicURL
              ext
            }
            name
            key
          }
        }
      }
    `);
  const downloads = data.strapiGlobalModules.downloads;

  // Remove "download_" prefix
  let fileLink = null;
  let fileName = null;
  if (props.fileName) {
    let key = props.fileName.replace("download_", "");

    // Find the document by key
    let doc = downloads.find(d => d.key === key);

    // Get the file link (if found)
    let file = doc ? doc.file : null;
    fileName = doc ? slugify(doc.name) + doc.file?.ext : null;
    if (file) {
      fileLink = process.env.GATSBY_SITE_URL + file.publicURL;
    }

  }

  return (
    <div className="download-pdf">
      <ModalTiny show={props.openForm} onHide={() => { props.setOpenForm(false) }} className="book-a-viewing-modal download-pdf-modal">
        <ModalTiny.Header
          closeButton={props.disableClose ? false : true}
          className="contact-close-btn">
          <ModalTiny.Title className="w-100">
            <div className="text-center heading">WHAT YOU DON'T KNOW<br /> COULD COST YOU.</div>
            <div className="subhead">ENTER YOUR DETAILS TO<br />SECURE YOUR DISCOUNT TODAY</div>
            <div className="subdesc">& access your FREE Renters' Rights Act guide.</div>

          </ModalTiny.Title>
        </ModalTiny.Header>
        <ModalTiny.Body className="event-section">
          <p className="note">Not your usual small print - this offer lasts a whole 12 months.</p>
          <DownloadPDForm download_url={fileLink} fileName={fileName}  setOpenForm={props.setOpenForm}  />
        </ModalTiny.Body>
      </ModalTiny>

    </div>
  )
}

export default DownloadPDF
